import { initGeneral } from "../modules/general.js";
import { initAccordion } from "../modules/accordion.js";

jQuery(document).ready(function ($) {
	initGeneral();
	initAccordion();
});
